import React from "react";

export default class NoAddressModal extends React.Component<any> {
  state = {
    open: false,
    notes: null,
  };

  constructor(props) {
    super(props);
  }

  handleClose = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  };

  render() {
    let modalDisplay = {};
    let backdropClass = "";

    backdropClass = "modal-backdrop show";
    modalDisplay = { display: "block" };
    return (
      <>
        <div className={backdropClass}></div>
        <div className="modal" style={modalDisplay}>
          <div
            className="modal-dialog modal-dialog-vertical-center"
            role="document"
          >
            <div className="modal-content bd-0 tx-14" style={{ width: 350 }}>
              <div className="pd-y-20 pd-x-25">
                <h6 style={{display: "inline-flex", paddingLeft: "75px"}} className="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
                  Information Needed
                </h6>
                <button
                  onClick={() => {this.props.editAddress(); this.props.close()}}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" style={{paddingTop:0,paddingBottom:25}}>
                <div className="mg-b-0 text-center black">
                  {/* <img className="mg-y-20" src="./../img/exclamation.png" height="100" /> */}
                  <div className="bold tx-20 mg-b-15 pd-t-5">Please update your address information</div>
                  <div style={{textAlign: "left"}}>You will not be able to proceed until this step has been completed.</div>
                  {/* <div className="mg-t-15">Scroll down to edit or delete submitted images</div> */}
                </div>
              </div>
              <div className="modal-footer" style={{justifyContent: "flex-end"}}>
                <button
                  onClick={() => {this.props.editAddress(); this.props.close()}}
                  type="button"
                  className="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-medium"
                  data-dismiss="modal"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
